import { useMemo, useRef } from "react";
import { CatmullRomCurve3, DoubleSide, Vector3 } from "three";

import { useThree, useFrame } from "@react-three/fiber";
import { TubeGeometry } from "three";
import { useEffect } from "react";

const DynamicTube = ({ tubeRadius = 0.018, segments = 10, pointRefs = [], update = false, material, ...props }) => {
  const tubeRef = useRef();
  const updateRef = useRef(false);

  const pointVectors = useMemo(() => {
    var vectors = [];
    pointRefs.forEach(() => vectors.push(new Vector3()));
    return vectors;
  }, [pointRefs]);

  const curve = useMemo(() => {
    return new CatmullRomCurve3();
  });

  const getCurve = () => {
    pointRefs.forEach((p, i) => {
      p.getWorldPosition(pointVectors[i]);
    });

    curve.points = pointVectors;
    return curve;
  };

  useFrame(() => {
    if (tubeRef.current && updateRef.current) {
      tubeRef.current.geometry = new TubeGeometry(getCurve(), segments, tubeRadius);
    }
  });

  useEffect(() => {
    if (update) {
      updateRef.current = true;
    } else {
      setTimeout(() => {
        updateRef.current = false;
      }, 64);
    }
  }, [update]);

  return (
    <mesh {...props} ref={tubeRef}>
      <tubeGeometry args={[getCurve(), segments, tubeRadius]} />
      {material != null ? (
        <primitive object={material} attach="material" />
      ) : (
        <meshStandardMaterial color="#1d242b" metalness={0.1} roughness={0.8} side={DoubleSide} />
      )}
    </mesh>
  );
};

export default DynamicTube;
